var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 16,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 7,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 7,
    height: 2,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2793 12.7475C10.1004 12.5875 10 12.3711 10 12.1456C10 11.92 10.1004 11.7036 10.2793 11.5437L13.6796 8.47866L10.2793 5.45634C10.1004 5.29638 10 5.07999 10 4.85444C10 4.62889 10.1004 4.4125 10.2793 4.25254C10.3686 4.17252 10.4748 4.109 10.5919 4.06566C10.7089 4.02232 10.8345 4 10.9613 4C11.0881 4 11.2136 4.02232 11.3307 4.06566C11.4477 4.109 11.554 4.17252 11.6433 4.25254L15.7159 7.87249C15.8059 7.95185 15.8774 8.04628 15.9261 8.15032C15.9749 8.25436 16 8.36595 16 8.47866C16 8.59136 15.9749 8.70295 15.9261 8.80699C15.8774 8.91103 15.8059 9.00546 15.7159 9.08483L11.6433 12.7475C11.554 12.8275 11.4477 12.891 11.3307 12.9343C11.2136 12.9777 11.0881 13 10.9613 13C10.8345 13 10.7089 12.9777 10.5919 12.9343C10.4748 12.891 10.3686 12.8275 10.2793 12.7475Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOpen);
export default __webpack_public_path__ + "static/media/sidebarOpen.ced8928be7f762e8e6c5f3cfa7149f3f.svg";
export { ForwardRef as ReactComponent };